<span (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
  <p-tag>{{tag.name}}@if (isMouseHover() && editMode) {
    <i style="cursor: pointer" class="pi pi-times-circle ml-1" (click)="removeTag(tag)"></i>
  }</p-tag>
</span>